<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <hr />
            <p class="text-center">{{copyright}}</p>
        </div>
    </div>
  </div>